import { Badge, Button, CardContainer } from 'src/components/atoms';
import styled from 'styled-components';

export const StyledCardContainer = styled(CardContainer)`
  margin-bottom: 24px;
`;

export const ReportCardContainer = styled.div<{
  version: 'report-list' | 'report-view';
}>`
  padding: 16px;
  display: flex;

  gap: 16px;
  font-size: 14px;

  ${(props) => {
    if (props.version === 'report-list') {
      return `flex-direction: column;`;
    }

    if (props.version === 'report-view')
      return `
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      `;
  }}

  @media (max-width: 768px) {
    padding: 16px;
    gap: 8px;

    ${(props) => {
      if (props.version === 'report-view') {
        return `
        flex-direction: column;
        align-items: flex-start;
      `;
      }
    }}
  }
  @media (max-width: 576px) {
    padding: 16px;
    gap: 4px;
  }
  @media (max-width: 480px) {
    padding: 16px;
    gap: 2px;
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const CategoryLabel = styled.h4`
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 500;
`;

export const StatusContainer = styled.div<{
  version: 'report-list' | 'report-view' | 'report-messages';
}>`
  flex: 1;
  display: flex;
  justify-content: ${({ version }) =>
    version === 'report-view' ? 'flex-start' : 'flex-end'};
`;

export const ReportTitleDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  i {
    margin-right: 8px;
  }
  @media (max-width: 768px) {
    gap: 8px;
    flex-direction: column;
    margin-top: 8px;
    width: 100%;
  }
`;

export const LastButton = styled(Button)`
  margin-left: auto;
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const ReadableIdWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ReadableId = styled.span`
  padding: 4px 8px;
  margin-left: 8px;
  border-radius: 4px;
  background-color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N200
      : theme.atlas.core.color.gray[100]};
`;

export const SubmittedAt = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 11px;
  color: ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newPalette.neutral.N600
      : theme.atlas.semantic.color.type.muted};
  margin-top: 4px;
  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const MessageCountBadge = styled(Badge)`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(30%, -30%);
  font-size: 10px';
  width:'20px';
  height:'20px'
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: default;
`;

export const ButtonWithMessageCountContainer = styled(Button)`
  position: relative;
`;
